export default "__VITE_ASSET__MV5lWn4R__"